module.exports = __webpack_public_path__ + "static/media/blrss3.b99520e9.png";